<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <qiyeHeader :activeIndex="4" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">职业发布数据</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-s-custom"></i></div>
      <div class="gerenxinxi">职业发布数据</div>
    </div>
    <div class="head01">
      <qiyeHeader :activeIndex="4" v-if="!isMobile" />
      <div class="neirong">
        <el-row :gutter="20" v-if="!isMobile">
          <el-col :span="spanSize(index)" v-for="(job, index) in pageJobs" :key="index" style="margin-left: 29px;">
            <el-card :body-style="{ padding: '20px' }" class="cardjob">
              <div @click="showDetails(job)">
                <h3 class="job-name"> {{ job.jobName }}</h3>
                <p class="salary">薪资范围：{{ job.minSalary }} - {{ job.maxSalary }}</p>
                <p class="workplace">工作地点：{{ job.workplace }}</p>
                <p class="skills">技能要求：{{ formatSkills(job.skills) }}</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <div class="job-list" v-else>
          <div v-for="(job, index) in pageJobs" :key="index" class="job-item" @click="showDetails(job)">
            <h3 class="job-name">{{ job.jobName }}</h3>
            <p class="salary">薪资范围：{{ job.minSalary }} - {{ job.maxSalary }}</p>
            <p class="workplace">工作地点：{{ job.workplace }}</p>
            <p class="skills">技能要求：{{ formatSkills(job.skills) }}</p>
          </div>
        </div>
        <el-dialog :visible.sync="isShow" title="修改职位信息" @close="qvxiao" class="zhiwei">
          <el-form ref="form" :model="form" label-width="80px" class="centered-form" @submit.prevent="onSubmit">
            <el-form-item label="职位名称" prop="jobName">
              <el-input v-model="form.jobName" :rules="[{ required: true, message: '职位名称不能为空', trigger: 'blur' }]"
                class="kuandu" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="工作地点" prop="workplace">
              <el-select v-model="form.workplace" placeholder="工作地点" class="kuandu"
                :rules="[{ required: true, message: '请选择工作地点', trigger: 'change' }]">
                <el-option v-for="(item, index) in workplaces" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="薪资范围">
              <el-input type="number" placeholder="最低值" v-model="form.minSalary" class="kuandu1"
                :rules="[{ required: true, message: '最低薪资不能为空', trigger: 'blur' }]"></el-input>
              <span>-</span>
              <el-input type="number" placeholder="最高值" v-model="form.maxSalary" class="kuandu1"
                :rules="[{ required: true, message: '最高薪资不能为空', trigger: 'blur' }]"></el-input>
            </el-form-item>
            <el-form-item label="岗位职责" prop="jobDuties">
              <el-input type="textarea" v-model="form.jobDuties" class="kuandu"
                :rules="[{ required: true, message: '岗位职责不能为空', trigger: 'blur' }]"></el-input>
            </el-form-item>
            <el-form-item label="学历要求" prop="degree">
              <el-select v-model="form.degree" placeholder="请选择" class="kuandu"
                :rules="[{ required: true, message: '请选择学历要求', trigger: 'change' }]">
                <el-option v-for="item in degrees" :key="item.degree" :label="item.label"
                  :value="item.degree"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="专业要求" prop="major">
              <el-cascader v-model="form.major" placeholder="请选择专业" :options="majors" @change="handleChange"
                :props="{ multiple: true, emitPath: false }" filterable class="kuandu">
              </el-cascader>
            </el-form-item>
            <el-form-item label="证书要求" prop="certificate">
              <el-input v-model="form.certificate" class="kuandu"
                :rules="[{ required: true, message: '证书要求不能为空', trigger: 'blur' }]"></el-input>
            </el-form-item>
            <el-form-item label="技能要求" prop="skills">
              <el-input type="textarea" v-model="form.skills" class="kuandu"
                :rules="[{ required: true, message: '技能要求不能为空', trigger: 'blur' }]"></el-input>
            </el-form-item>
            <el-form-item label="是否发布">
              <el-switch v-model="form.draft" :active-value="0" :inactive-value="1"></el-switch>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">修改</el-button>
              <el-button @click="qvxiao">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <el-pagination :current-page="currentPage" :page-size="8" :total="total" @current-change="handlePageChange"
          layout="prev, pager, next" style="margin-top: 20px; text-align: center;" />
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import qiyeHeader from './qiyeHeader.vue';
import Footer from './Footer.vue'
export default {
  name: 'JobBoard',
  components: {
    qiyeHeader,
    Footer
  },
  data() {
    return {
      BASE_URL: 'https://zhiyedashi.com/job',
      BASE_URL2: 'https://zhiyedashi.com/school',
      qiyeId: sessionStorage.getItem("qiyeId"),
      jobList: [],
      currentPage: 1,
      pageJobs: [],
      total: 0,
      degrees: [{
        degree: '不限',
        label: '不限'
      }, {
        degree: '专科及以上',
        label: '专科及以上'
      }, {
        degree: '本科及以上',
        label: '本科及以上'
      }, {
        degree: '研究生及以上',
        label: '研究生及以上'
      }, {
        degree: '博士及以上',
        label: '博士及以上'
      }],
      majors: [],
      majordaima: '',
      form: {
        id: 0,
        jobName: '',
        workplace: '',
        minSalary: '',
        maxSalary: '',
        jobDuties: [],
        degree: '',
        major: [],
        certificate: [],
        skills: [],
        draft: null
      },
      isShow: false,
      workplaces: [],
      isMobile: false
    }
  },
  created() {
    // 1. 判断关键数据是否存在
    if (!this.qiyeId) {
      // 2. 提前返回，跳过后续所有代码
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  mounted() {
    this.selectJobList()
    this.selectMajor()
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    selectMajor() {
      fetch(`${this.BASE_URL2}/admin/api/majors`)
        .then(res => res.json())
        .then(data => {
          this.majors = data.data
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    formatSkills(skills) {
      const skillsArray = JSON.parse(skills);
      const formattedText = skillsArray.join(" ");
      return formattedText;
    },
    spanSize(index) {
      const totalColumns = 4;
      const currentRow = Math.floor(index / totalColumns);
      const itemsInRow = this.pageJobs.slice(currentRow * totalColumns, (currentRow + 1) * totalColumns).length;

      // 如果当前行有满4列，给每列分配 6 个 span（4列）
      if (itemsInRow === totalColumns) {
        return 5; // 每个卡片占 6 span，4 个卡片正好撑满 24 span
      } else {
        return Math.floor(24 / itemsInRow);
      }
    },
    qvxiao() {
      this.isShow = false
    },
    convertTextToArrayString(text, delimiter = '\n') {
      if (!text) return '[]';

      try {
        const array = JSON.parse(text);
        if (Array.isArray(array)) {
          return text;
        }
      } catch (e) {
      }

      try {
        // 按分隔符拆分并转换为JSON数组字符串
        const array = text.split(delimiter).filter(item => item.trim() !== '');
        return JSON.stringify(array);
      } catch (e) {
        console.error('转换回JSON数组失败:', e);
        return '[]'; // 失败时返回空数组
      }
    },
    onSubmit() {
      let qiyeJob = {
        id: this.form.id,
        qiyeId: this.qiyeId,
        jobName: this.form.jobName,
        workplace: this.form.workplace,
        minSalary: this.form.minSalary,
        maxSalary: this.form.maxSalary,
        jobDuties: this.convertTextToArrayString(this.form.jobDuties),
        degree: this.form.degree,
        major: this.majordaima,
        certificate: this.convertTextToArrayString(this.form.certificate, '，'),
        skills: this.convertTextToArrayString(this.form.skills),
        draft: this.form.draft
      }
      fetch(`${this.BASE_URL}/admin/qiyejob/saveJob`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(qiyeJob)
      })
        .then(res => res.json())
        .then(data => {
          // console.log("修改成功", data);
          if (data.code === 200 && data.data === '修改成功') {
            // 跳转页面职位发布页面
            this.isShow = false
            this.selectJobList()
          }
        })
        .catch(error => {
          console.error("保存失败", error);
        })
    },
    handleChange(selectedValues) {
      this.form.majorLabels = [];
      this.majors.forEach(category => {
        category.children.forEach(major => {
          if (selectedValues.includes(major.value)) {
            this.form.majorLabels.push(major.label);
          }
        });
      });
      this.majordaima = JSON.stringify(this.form.majorLabels)
    },
    showDetails(job) {
      this.isShow = true;
      // console.log("卡片信息", job);
      this.workplaces = JSON.parse(job.workplaces)
      this.form = Object.assign({}, job);
      this.form.major = JSON.parse(job.major)
      this.majors.forEach(category => {
        category.children.forEach(major => {
          try {
            const selectedMajors = JSON.parse(job.major || '[]'); // 防止 job.major 为/undefined
            if (selectedMajors.includes(major.label)) {
              this.form.major.push(major.value);
            }
          } catch (e) {
            console.error('解析 job.major 失败:', e);
          }
        });
      })
      this.majordaima = job.major
      if (job.certificate) {
        this.form.certificate = this.convertArrayStringToText(job.certificate, '，');
      }
      if (job.jobDuties) {
        this.form.jobDuties = this.convertArrayStringToText(job.jobDuties);
      }
      if (job.skills) {
        this.form.skills = this.convertArrayStringToText(job.skills);
      }
    },
    convertArrayStringToText(arrayString, delimiter = '\n') {
      try {
        const array = JSON.parse(arrayString);
        return Array.isArray(array) ? array.join(delimiter) : arrayString;
      } catch (e) {
        console.error('解析 JSON 数组失败:', e);
        return arrayString; // 如果解析失败，返回原字符串
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.pagedJobs()
    },
    selectJobList() {
      fetch(`${this.BASE_URL}/admin/qiyejob/selectByUserId`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `qiyeId=${this.qiyeId}`
      })
        .then(res => res.json())
        .then(data => {
          // console.log("data数据", data);
          this.jobList = data.data
          this.total = this.jobList.length
          this.pagedJobs()
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    },
    pagedJobs() {
      if (!this.jobList || this.jobList.length === 0) return []; // 防止jobList为空时报错
      const startIndex = (this.currentPage - 1) * 8;
      const endIndex = startIndex + 8;
      this.pageJobs = this.jobList.slice(startIndex, endIndex);
    }
  }
}
</script>

<style>
.el-input.is-disabled .el-input__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-textarea.is-disabled .el-textarea__inner {
  border: none !important;
  color: #000000 !important;
  font-size: 17px !important;
}

.el-dialog {
  width: 30%;
}

@media (max-width: 768px) {
  .el-dialog {
    width: 97% !important;
  }
}
</style>

<style scoped>
.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 90px;
}

.neirong {
  justify-content: center;
  align-items: center;
  gap: 25px;
  margin-top: 50px;
  height: 75vh;
  width: 73%;
  border: 3px solid #c5ced7;
  border-radius: 50px;
  display: flex;
  flex-direction: column;
}

.span {
  margin-right: 7px;
  width: 80px;
  display: inline-block;
  text-align: right;
}

.kuandu {
  width: 350px;
}

.kuandu1 {
  width: 169px;
}

.juzhong {
  display: flex;
  justify-content: center;
  align-items: center;
}

.job-name {
  font-size: 18px;
  font-weight: bold;
}

.salary,
.workplace,
.skills {
  font-size: 14px;
  margin-bottom: 8px;
  color: #555;
}

.salary {
  font-weight: 600;
}

.workplace {
  color: #666;
}

.skills {
  font-style: italic;
}

.cardjob {
  height: 250px;
  width: 300px;
  margin-top: 20px;
  justify-content: space-around;
}

.zhiwei {
  width: 100%;
}

@media (max-width: 768px) {
  .job-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
  }

  .job-item {
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .job-name {
    font-size: 16px;
    font-weight: bold;
  }

  .salary,
  .workplace,
  .skills {
    font-size: 12px;
    color: #666;
  }

  .logo {
    width: 50px;
  }

  .zhiwei {
    width: 100%;
  }

  .head01 {
    flex-direction: column;
    gap: 20px;
    padding-top: 140px;
  }

  .neirong {
    width: 100%;
    border-radius: 20px;
    gap: 15px;
    margin-top: 15px;
    height: 100%;
  }

  .el-dialog {
    width: 97%;
  }

  .kuandu {
    width: 250px;
  }

  .kuandu1 {
    width: 110px;
  }

  .span {
    width: 70px;
    font-size: 14px;
  }

  .cardjob {
    width: 280px;
    height: 230px;
    margin-top: 15px;
  }

  .job-name {
    font-size: 16px;
  }

  .salary,
  .workplace,
  .skills {
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/JobBoard.vue